import { useCallback } from 'react';
import { axiosPosthogClient } from 'Api';
import { PosthogProviderViewProps } from '../types';

export function usePosthogProviderController(
  posthog_distinct_id: PosthogProviderViewProps['posthog_distinct_id'],
) {
  const sendEvent = useCallback(
    (event: string, properties?: any) => {
      if (
        posthog_distinct_id &&
        process.env.REACT_APP_POSTHOG_HOST &&
        process.env.REACT_APP_POSTHOG_KEY
      ) {
        axiosPosthogClient.post('/capture/', {
          api_key: process.env.REACT_APP_POSTHOG_KEY,
          event,
          distinct_id: posthog_distinct_id,
          properties,
          timestamp: new Date().toISOString(),
        });
      }
    },
    [posthog_distinct_id],
  );

  return {
    sendEvent,
  };
}
